
  <div class="p-col-12">

      <!-- FILTRE ENTETE -->
      <p-header>
        <!--   SECTION Volumetrie -->
        <div class="p-grid">
          <div class="p-col-12 p-lg-6 p-xl-6">
           
          </div>
          <!--   SECTION DATE -->
          <div class="p-col-12 p-md-6 p-lg-4 p-xl-4">
            <button class="ui-fluid search" pButton [iconPos]="'right'" style="width: 100%; background-color: antiquewhite; border-color: antiquewhite; color:black; font-weight: bold;" icon="pi pi-calendar" label="Calendrier"  (click)="dateOverlay.toggle($event)"></button>
            <p-overlayPanel #dateOverlay [appendTo]="'body'">
              <p-tabView  [(activeIndex)]="activeIndexTabView">
                <p-tabPanel header="Jour">
                  <p-calendar [(ngModel)]="valueDate" [locale]="fr" [inline]="true" dateFormat="yy-mm-dd" styleClass="yourClass"></p-calendar>
                </p-tabPanel>
                <p-tabPanel header="Semaine">
                  <p-calendar [(ngModel)]="valueSemaine" [inline]="true" selectionMode="range" [locale]="fr"
                              (onSelect)="selectRangeWeek($event)" dateFormat="yy-mm-dd" [yearNavigator]="true" [showWeek]="true" yearRange="2000:2030"></p-calendar>
                </p-tabPanel>
                <p-tabPanel header="Mois">
                  <p-calendar [(ngModel)]="valuMois" [inline]="true" view="month" dateFormat="yy-mm" [locale]="fr" [yearNavigator]="true" yearRange="2000:2030"></p-calendar>
                </p-tabPanel>
                <p-tabPanel header="Periode">
                  <p-calendar [(ngModel)]="valuePeriode" [inline]="true" selectionMode="range" [locale]="fr"
                              dateFormat="yy-mm-dd" [yearNavigator]="true" [showWeek]="true" yearRange="2000:2030"></p-calendar>
                </p-tabPanel>
              </p-tabView>
            </p-overlayPanel>
          </div>
          <!--   SECTION BOUTTON AFFICHER -->
          <div class=" p-col-12 p-md-6  p-lg-2 p-xl-2">
            <p-button class="ui-fluid search" [iconPos]="'right'" style="width: 100%;" icon="pi pi-search" label="Afficher" (onClick)="loadFiltreReporting()"></p-button>
          </div>
        </div>
      </p-header>
  </div>
  <!-- AFFICHAGE DATE DEBUT DATE FIN-->

      <div class="p-col-12" style="font-family: 'Open Sans', 'Helvetica Neue', sans-serif; text-align: center;">
        <h2> REPORTING du {{dateDebutFiltre}}        au       {{dateFinFiltre}} </h2>
      </div>




  <!--   ******************************              REPORTING GENERALE                    ***********************************    -->

    <p-panel header="GENERAL" style="height: 600px" class="reporting">

     </p-panel>



     <div class="p-grid p-align-stretch vertical-container">

        <!--    NOMBRE FICHE RECUES     -->
        <div class="p-col-12 p-md-6 p-lg-3 p-xl-3">
          <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
            <p-header class="center-header">
              Fiches reçues
            </p-header>
            <div class="center-number">
              <div>{{FicheRecues}}</div>
            </div>
          </p-panel>
      </div>
      <!--    NOMBRE FICHE TRAITEES     -->
      <div class="p-col-12 p-md-6 p-lg-3 p-xl-3">
        <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
          <p-header class="center-header">
            Fiches livrées
          </p-header>
          <div class="center-number">
            <div >{{FicheTraitees}}</div>
          </div>
        </p-panel>
      </div>


      <!--       MATURITE MOYENNE TRAITEMENT  -->
      <div class="p-col-12 p-md-6 p-lg-3 p-xl-3" *ngIf="!isClient()">
        <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
          <p-header class="center-header">
            DMT moyenne traitement
          </p-header>
          <span style="font-size: 17px; font-weight: bold">
            <p class="p-m-0">
              <br><br>
              Initiales : {{dureeMoyenneTraitementInitial}} (Max : {{dmtGlobalAccepteInitial}})
            </p>
            <p class="p-m-0">
              <br><br>
              Retours : {{dureeMoyenneTraitementRetour}}  (Max : {{dmtGlobalAccepteRetour}})
            </p>
          </span>
        </p-panel>
      </div>



      <!--       MATURITE MOYENNE TRAITEMENT  -->
      <div class="p-col-12 p-md-6 p-lg-3 p-xl-3" *ngIf="!isClient()">
        <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
          <p-header class="center-header">
            DMT moyenne Initiales
          </p-header>
          <span style="font-size: 17px; font-weight: bold">
            <p class="p-m-0">
              <br><br>
              Faible : {{dmtinitiale.faible}}
              <br><br>
              Moyenne : {{dmtinitiale.moyenne}}
              <br><br>
              Forte : {{dmtinitiale.forte}}
            </p>
          </span>
        </p-panel>
      </div>

      <!--       MATURITE MOYENNE TRAITEMENT  -->
      <div class="p-col-12 p-md-6 p-lg-3 p-xl-3" *ngIf="!isClient()">
        <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
          <p-header class="center-header">
            DMT moyenne Retours
          </p-header>
          <span style="font-size: 17px; font-weight: bold">
            <p class="p-m-0">
              <br><br>
              Faible : {{dmtRetour.faible}}
              <br><br>
              Moyenne : {{dmtRetour.moyenne}}
              <br><br>
              Forte : {{dmtRetour.forte}}
            </p>
          </span>
        </p-panel>
      </div>

      <!--       MATURITE MOYENNE TRAITEMENT  -->
      <div class="p-col-12 p-md-6 p-lg-3 p-xl-3" *ngIf="!isClient()">
        <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
          <p-header class="center-header">
            Maturité moyenne
          </p-header>
          <span style="font-size: 17px; font-weight: bold">
            <p class="p-m-0">
              <br><br>
              Initiales : {{maturiteInitiale}}
            </p>
            <p class="p-m-0">
              <br><br>
              Retours : {{maturiteRetour}}
            </p>
          </span>
        </p-panel>
      </div>
      <!--                   NOMBRE TOTAL DE FICHE KO EN ATTENTE                                -->
      <div class="p-col-12 p-md-6 p-lg-3 p-xl-3" *ngIf="!isClient()">
        <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
          <p-header class="center-header">
            Nbre total de fiches KO en attente retour PTL
          </p-header>
          <div class="center-number">
            <div >{{NombreTotalFicheKO}}</div>
          </div>
        </p-panel>
      </div>

       <!--                    AFFICHER   GRAPH OK KO                     -->
       <div [class]="(isClient()) ? 'p-col-12  p-lg-6 p-xl-6' : 'p-col-12 p-md-6 p-lg-3 p-xl-3'">
         <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
           <p-header class="center-header">
             Ratio fiches acceptées/refusées
           </p-header>
           <p class="p-m-0">
             <p-chart [width] = "'450'" type="pie" style="max-height: 100%;" [data]="dataGraphePieGeneral" [options]="options" [plugins]="plugin" ></p-chart>
           </p>
         </p-panel>
       </div>
       <!--                   QUALITE INITIAL NOMBRE ECHANTILLON   ISO            -->
       <div class="p-col-12 p-md-6 p-lg-3 p-xl-3">
         <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
           <p-header class="center-header">
             Qualité ISO
           </p-header>
           <div class="center-number">
              <div >{{TauxQualiteISO}} %</div>
           </div>
         </p-panel>
       </div>
       <!--                   QUALITE INITIAL NOMBRE ECHANTILLON   CIBLE            -->
       <div class="p-col-12 p-md-6 p-lg-3 p-xl-3">
         <p-panel class="box box box-stretched" styleClass="fiches-recues" class="cards">
           <p-header class="center-header">
             Qualité CIBLE
           </p-header>

           <table style="width: 100%;color:darkslategray;height:100%;font-size:16px;text-align:left;margin-top:40px">
             <tr style="height: 80px;">
               <td>Nombre échantillonnage CIBLE</td>
               <td style="width: 2px;">:</td>
               <td>{{FicheEchantillonerCIBLE}}</td>
             </tr>
             <tr style="height: 80px;">
              <td>Taux de qualité</td>
              <td style="width: 2px;">:</td>
              <td>{{TauxQualiteCIBLE}}%</td>
            </tr>
           </table>
         </p-panel>
       </div>
     </div>

  <!---  ********************************************       DETAIL TABLEAU             ******************************************************  --->
